var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1313,
    height: 76,
    viewBox: "0 0 1313 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1312.04 16.3467C1312.76 15.5326 1312.67 14.2697 1311.83 13.526L1298.18 1.40547C1297.34 0.661698 1296.07 0.718697 1295.35 1.53278C1294.63 2.34687 1294.72 3.60976 1295.56 4.35353L1307.69 15.1273L1297.22 26.9195C1296.5 27.7336 1296.6 28.9965 1297.43 29.7403C1298.27 30.4841 1299.54 30.4271 1300.26 29.613L1312.04 16.3467ZM1.18875 75.9946L1310.67 16.9946L1310.37 13.0054L0.894256 72.0054L1.18875 75.9946Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.53f405e559bf0998663ebea16caedaff.svg";
export { ForwardRef as ReactComponent };